import api from "./api";
import xhr from "xhr";
import validator from "./type_validator";
import setOrigin from "./setOrigin";

const newsletter = () => {
  const currentPage = document.querySelector(".page__form-newsletter"),
    campaignSlug = currentPage.getAttribute("data-campaign"),
    campaignFormSlug = currentPage.getAttribute("data-form"),
    vehicule_id = currentPage.getAttribute("data-id"),
    submitBtn = document.querySelector('button[type="submit"]');

    let checkedRadioValue = 0,
        radios = document.getElementsByName("civility");

    for (let i = 0, length = radios.length; i < length; i++) {
        if (radios[i].checked) {
            checkedRadioValue = radios[i].value;
            break;
        }
    }

  return {
    formSubmission: () => {
      let payload = {
        origin: `${setOrigin()}`,
        campaign_id: currentPage.getAttribute("data-campaign-id"),
        tl: currentPage.getAttribute("data-tl"),
        lead: {
          firstname: document.querySelector("#firstname").value,
          lastname: document.querySelector("#lastname").value,
          civility: checkedRadioValue,
          email: document.querySelector("#email").value,
          mobile: document.getElementById("phone") ? document.getElementById("phone").value : ''
        },
        consents: {
          purpose: currentPage.getAttribute("data-purpose"),
          policy_name: currentPage.getAttribute("data-policy-name"),
          policy_version: currentPage.getAttribute("data-policy-version"),
        //   consent_email: document.querySelector("#consentEmail").checked
        //     ? "1"
        //     : "0", // 1 if checkbox is checked / else 0
        //   consent_courrier: document.querySelector("#consentCourrier").checked
        //     ? "1"
        //     : "0",
        //   consent_message: document.querySelector("#consentPhoneService")
        //     .checked
        //     ? "1"
        //     : "0",
        //   consent_vehicule: document.querySelector(
        //     "#consentCarConnectedService"
        //   ).checked
        //     ? "1"
        //     : "0",
          consentMarketing: (document.querySelector("#consentMarketing") && document.querySelector("#consentMarketing").checked) ? "1" : "0",
          consent: (document.querySelector("#consentGeneral") && document.querySelector("#consentGeneral").checked) ? "1" : "0"
        },
        preview: window.location.href.indexOf("preview") >= 0 ? "1" : "0",
        transaction_id: currentPage.getAttribute("data-transaction-id"),
        offer_id: currentPage.getAttribute("data-offer-id")
      };

      // On vérifie le besoin d'envoyer le sujet de la newsletter
      let subjectChecks = document.querySelectorAll('input[type="checkbox"][name="newsletter_subject"]');
      if (subjectChecks.length) {
        payload.lead.newsletter_subject = [];
      }
      for(let i=0; i < subjectChecks.length; i++) {
        if (subjectChecks[i].checked) {
          payload.lead.newsletter_subject.push(subjectChecks[i].value);
        }
      }

      let requestParams = `${window.location.search.slice(1)}`;
      let link = "";

      if(typeof confirmUrl !== 'undefined') {
        link = `${api().bmw}` +  confirmUrl.replace(api().appPrefix, '');
        if (requestParams) {
          link = link + '?' + requestParams;
        }
      } else {
        if (requestParams) {
          link = `${
            api().bmw
          }/${campaignSlug}/${campaignFormSlug}/confirm?${requestParams}`;
        } else {
        link = `${api().bmw}/${campaignSlug}/${campaignFormSlug}/confirm`;
        }
      }

      xhr(
        {
          method: "POST",
          body: JSON.stringify(payload),
          uri: `${
          api().bmw
          }/${campaignSlug}/${campaignFormSlug}/${vehicule_id}/validate`,
          headers: {
            "Content-Type": "application/json"
          },
          "Access-Control-Allow-Origin": `${
          api().bmw
          }/${campaignSlug}/${campaignFormSlug}/${vehicule_id}/validate`
        },
        (err, resp, body) => {
          let data = JSON.parse(body);
          if (data.status == "ok") {
            if (typeof dataLayer !== 'undefined') {
              dataLayer.push(payload);
            }
            if (requestParams) {
              window.location.href = `${link}`  + '&hash=' + data.hash;
            } else {
              window.location.href = `${link}`  + '?hash=' + data.hash;
            }
          } else {
            const res = JSON.parse(resp.body);
            for (const key in res) {
              if (res.hasOwnProperty(key)) {
                const element = res[key];
                if (element === false) {
                  let falseInput = document.getElementById(`${key}`);
                  falseInput.parentElement.classList.add("error");
                  validator().showErrorMsg(falseInput);
                }
              }
            }
            submitBtn.classList.remove("disabled");
            submitBtn.disabled = false;
          }
        }
      );
    }
  };
};
export default newsletter;
